export default __webpack_public_path__ + "static/media/logo-full-white.57d6c055.svg";